<template>
	<div>
		<div>
		<div @click="emitRange" id="my-slider" :se-min="minValue" :se-step="step" :se-min-value="defaultMinValue" :se-max-value="defaultMaxValue" :se-max="maxValue" class="slider">
				<div class="justify: space-around;">
					<div class="category">{{category}}</div>
					<div class="selected-values">
						<div style="float: left;margin-right:5px;" id="min-scale"></div>
						 -
						<div style="float: right;margin-left:5px;" id="max-scale"></div>
					</div>
				</div>
			<div class="slider-touch-left">
		  <span></span>
   </div>
   <div class="slider-touch-right">
     <span></span>
   </div>
   <div class="slider-line">
     <span></span>
   </div>
  </div>
		</div>
		<div id="result" class="scale-values">
			<div class="min-scale-value">{{minValue}}</div>
			<div class="max-scale-value">{{maxValue}}</div>
		</div>
	</div>
</template>


<script>
import "./SSlider/s-slider.js";
import { initialize } from "./SSlider/s-slider.js";

export default {
	name: 'SSlider',

	mounted(){
		initialize();
		if(this.defaultMinValue){
			document.getElementById('min-scale').innerHTML = this.defaultMinValue;
		}

		if(this.defaultMaxValue){
			document.getElementById('max-scale').innerHTML = this.defaultMaxValue;
		}
	},

	props: {
		minValue: {
			type: Number
		},
		maxValue: {
			type: Number
		},
		category: {
			type: String
		},
		defaultMinValue: {
			type: Number
		},
		defaultMaxValue: {
			type: Number
		},
		step: {
	        type: Number,
	        default: 1
	    },
	},

	methods: {
		emitRange(){
			let min = document.getElementById('min-scale').innerHTML;
			let max = document.getElementById('max-scale').innerHTML;
			let values = {
				minimum: min,
				maximum: max
			};

			this.$emit('updated-range', values);

		}
	}

}
</script>

<style lang="scss" scoped>
 @mixin border-box($val: border-box){
    -webkit-box-sizing: $val;
    -moz-box-sizing:    $val;
    box-sizing:         $val;
}

.slider {
	display: block;
	position: relative;
	height: 36px;
	width: 100%;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select:none;
	-o-user-select:none;
	user-select:none;

	.slider-touch-left, .slider-touch-right {
		@include border-box();
		display: block;
		position: absolute;
		height: 36px;
		width: 36px;
		padding: 6px;
		z-index: 2;
		cursor: pointer;

		span {
			display: block;
			width: 16px;
			height: 16px;
			background: #F0F0F0;
			border: 1px solid #A4A4A4;
			border-radius: 50%;
			position: relative;
			bottom: -4px;
		}
	}

	.slider-line {
		@include border-box();
		position: absolute;
		width: calc(#{"100% - 36px"});
		left: 18px;
		top: 16px;
		height: 4px;
		border-radius: 4px;
		background: var(--very-light-pink);
		z-index: 0;
		overflow: hidden;

		span {
			display: block;
			height: 100%;
			width: 0%;
			background: var(--success);
		}
	}
}

.scale-values{
	display: inline-flex;
	width: 98%;
}
.min-scale-value{
	width: 50%;
	margin-left: 16px;
	cursor: default;
}
.max-scale-value{
	width: 50%;
	text-align: end;
	cursor: default;
}
.selected-values{
	display: inline-flex;
    float: right;
    position: relative;
    bottom: 20px;
	margin-right: 2%;
	cursor: default;
}
.category{
	float: left;
    position: relative;
    bottom: 20px;
	margin-left: 2%;
	cursor: default;
}
</style>